import { j as c } from "../jsx-runtime-Wav_3Wde.js";
import { useState as h, useEffect as x } from "react";
import { styled as f } from "styled-components";
import { system as L, compose as C, layout as k } from "styled-system";
import { styledSvgColor as v } from "../Logo/StyledPath.mjs";
const b = L({
  opacity: !0
}), j = /* @__PURE__ */ f.svg.withConfig({
  componentId: "sc-777dc717-0"
})([
  "width:100%;height:100%;left:0;top:0;position:absolute;"
]), m = /* @__PURE__ */ f.line.withConfig({
  shouldForwardProp: (t) => ![
    "strokeColor"
  ].includes(t)
}).withConfig({
  componentId: "sc-777dc717-1"
})([
  "",
  " transition-property:opacity;transition-duration:0.01s;",
  ""
], ({ theme: t }) => t.components.iconSummaryPanel.line, C(k, v, b)), q = (t) => {
  const r = [], a = [];
  for (let n = 0; n < t.length - 1; n += 1) {
    const e = t[n], i = t[n + 1];
    r.push({
      x1: e.x + e.width * 0.8,
      x2: i.x - i.width * 0.8,
      y1: e.y,
      y2: e.y
    }), a.push({
      x1: e.x,
      x2: i.x,
      y1: e.y + e.height * 0.8,
      y2: i.y - i.height * 0.8
    });
  }
  return [
    a,
    r
  ];
}, I = ({ elements: t, lineColor: r }) => {
  const [a, n] = h([]), [e, i] = h([]);
  return x(() => {
    let s = !1;
    const o = () => {
      s || (window.requestAnimationFrame(() => {
        if (t.every((l) => l !== null)) {
          const l = t.map((p) => {
            const d = p.getBoundingClientRect(), g = p.offsetLeft + d.width / 2, w = p.offsetTop + d.height / 2;
            return {
              x: g,
              y: w,
              width: d.width,
              height: d.height
            };
          }), [u, y] = q(l);
          i(u), n(y), s = !1;
        }
      }), s = !0);
    };
    return window.addEventListener("resize", o), o(), () => {
      window.removeEventListener("resize", o);
    };
  }, [
    t
  ]), /* @__PURE__ */ c.jsx(c.Fragment, {
    children: /* @__PURE__ */ c.jsxs(j, {
      role: "img",
      "aria-hidden": !0,
      focusable: !1,
      "data-qa-id": "connection-lines",
      children: [
        e.map((s, o) => /* @__PURE__ */ c.jsx(m, {
          ...s,
          "data-qa-id": `ml-${o}`,
          strokeColor: r,
          opacity: [
            1,
            1,
            0
          ]
        }, o)),
        a.map((s, o) => /* @__PURE__ */ c.jsx(m, {
          "data-qa-id": `dtl-${o}`,
          opacity: [
            0,
            0,
            1
          ],
          strokeColor: r,
          ...s
        }, o))
      ]
    })
  });
};
export {
  I as default
};
